import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'open_with_faire-owf_soft_credit_check_modal_view-view';

/**
 * Track when the `Learn more` modal for the soft credit check disclaimer is viewed
 */
export function trackOpenWithFaireOwfSoftCreditCheckModalViewView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
